import { NSARouterMakerResult } from 'namirasoft-account-react';
import { IStorageLocal } from "namirasoft-core";
import { OfferItemOneOffModel, OfferItemRecurringModel, OfferItemRow, OfferItemType, OfferRow, SubscriptionRow } from 'namirasoft-payment';
import { NamirasoftMap } from "namirasoft-site-map";
import { IDFormatter, NSButtonBlue, NSDownTimer, NSLine, NSSpace, NSSpaceSizeType } from "namirasoft-site-react";
import { useParams } from "react-router-dom";
import { Fragment } from "react/jsx-runtime";
import { PaymentProps } from '../PaymentProps';
import { PaymentRoutes } from '../PaymentRoutes';
import Styles from './NSPOfferCard.module.css';
import NSPOfferItemCard from "./NSPOfferItemCard";

export interface NSPOfferCardProps extends NSARouterMakerResult, PaymentProps
{
    offer: OfferRow;
    offer_items: OfferItemRow[];
    subscription: SubscriptionRow | null;
    button?: {
        visible?: boolean;
        text?: string;
        onClick?: () => void;
    };
}

function NSPOfferCard(props: NSPOfferCardProps)
{
    let parmas = useParams();
    // title
    let offer_items = props.offer_items ?? [];
    let has_one_off = offer_items.some(o => o.type === OfferItemType.OneOff);
    let has_choosable = offer_items.some(o => o.type === OfferItemType.OneOff && o.one_off_model === OfferItemOneOffModel.Choosable);
    let has_recurring = offer_items.some(o => o.type === OfferItemType.Recurring && o.recurring_model !== OfferItemRecurringModel.Usage);
    let has_usage = offer_items.some(o => o.type === OfferItemType.Recurring && o.recurring_model === OfferItemRecurringModel.Usage);
    let title = "";
    if (props.button?.text)
        title = props.button?.text;
    else if (has_one_off && !has_recurring)
    {
        if (has_choosable)
            title = "Continue";
        else
            title = "Pay";
    }
    else if (!has_one_off && has_recurring)
        title = "Subscribe";
    else if (has_one_off && has_recurring)
        title = "Pay and Subscribe";
    else if (has_usage)
        title = "You Pay as You Go";
    let button_visible = props.button?.visible ?? true;

    let namirasoft = new NamirasoftMap(props.account.token_manager, props.notifier.onError);

    return (
        <div className={Styles.nsp_offer_card_container} style={{ backgroundColor: props.subscription ? "lightgreen" : "unset" }}>
            <div className={Styles.nsp_offer_card_body}>
                <div className={Styles.nsp_offer_card_top_segment}>
                    <div className={Styles.nsp_offer_card_recommended_child}
                        style={{
                            display: props.offer.recommended ? "block" : "none"
                        }}>
                        <img
                            src='https://static.namirasoft.com/image/concept/star/outline.svg'
                            alt=''
                            width={20}
                            height={20}
                        />
                        <h6>Recommended</h6>
                    </div>
                    <img src={props.offer.logo ?? undefined} alt='' width={128} height={128} />
                    <div className={Styles.nsp_offer_card_top_content}>
                        {new IDFormatter(namirasoft, new IStorageLocal()).format(props.offer.product_id, {} as any, {} as any, false)}
                        <h2>{props.offer.name}</h2>
                    </div>
                </div>
                <div className={Styles.nsp_offer_card_down_segment}>
                    {
                        props.offer.applies_at &&
                        <div className={Styles.nsp_offer_card_expire_segment}>
                            <NSDownTimer
                                date={new Date(props.offer.applies_at)}
                                text="Starts in"
                            />
                            <NSSpace size={NSSpaceSizeType.MINI} />
                            <NSLine style={{ width: "100%" }} />
                            <NSSpace size={NSSpaceSizeType.MINI} />
                        </div>
                    }
                    {
                        props.offer.expires_at &&
                        <div className={Styles.nsp_offer_card_expire_segment}>
                            <NSDownTimer
                                date={new Date(props.offer.expires_at)}
                                text="Expires in"
                            />
                            <NSSpace size={NSSpaceSizeType.MINI} />
                            <NSLine style={{ width: "100%" }} />
                            <NSSpace size={NSSpaceSizeType.MINI} />
                        </div>
                    }
                    {
                        offer_items.sort((a, b) => a.order - b.order).map((offer_item, index) =>
                        {
                            let needline = false;
                            if (props.offer_items)
                                needline = (index === props.offer_items.length - 1 || (offer_item.dominant) || (props.offer_items[index + 1].dominant));
                            return (
                                <Fragment key={props.offer.id}>
                                    <NSPOfferItemCard
                                        offer={props.offer}
                                        offer_item={offer_item}
                                    />
                                    {
                                        needline
                                            ?
                                            <>
                                                <NSSpace size={NSSpaceSizeType.MINI} />
                                                <NSLine style={{ width: "100%" }} />
                                                <NSSpace size={NSSpaceSizeType.MINI} />
                                            </>
                                            :
                                            <NSSpace size={NSSpaceSizeType.MICRO} />
                                    }
                                </Fragment>
                            );
                        })
                    }
                    {
                        props.offer.features &&
                        <>
                            <div className={Styles.nsp_offer_card_feature}>
                                {
                                    props.offer.features.split("\n").map(feature => (
                                        <div key={feature} className={Styles.nsp_offer_card_feature_item}>
                                            <img src={feature.startsWith("HAS:") ? "https://static.namirasoft.com/image/concept/check/on/green.svg" : "https://static.namirasoft.com/image/concept/close/error.svg"} alt="check" width={24} height={24}></img>
                                            <p>{feature.replace(/^HAS:/gm, "")}</p>
                                        </div>
                                    ))
                                }
                            </div>
                            <NSSpace size={NSSpaceSizeType.MINI} />
                            <NSLine style={{ width: "100%" }} />
                            <NSSpace size={NSSpaceSizeType.MINI} />
                        </>
                    }
                    {
                        props.offer.description &&
                        <div className={Styles.nsp_offer_card_description}>
                            <h5>Description:</h5>
                            <NSSpace size={NSSpaceSizeType.MICRO} />
                            <p>{props.offer.description}</p>
                        </div>
                    }
                    {
                        (props.subscription || button_visible) &&
                        <NSSpace size={NSSpaceSizeType.MEDUIM} />
                    }
                    {
                        props.subscription ?
                            <div className={Styles.nsp_offer_card_subscribed_section}>
                                <div style={{ position: "relative", width: "100%" }}>
                                    <div>
                                        <img width="100%" src="https://static.namirasoft.com/image/concept/ribbon/green.svg" alt="riboon">
                                        </img>
                                    </div>
                                    <div className={Styles.nsp_offer_card_subscribed_section_text} style={{ position: "absolute", top: "0px" }}>
                                        <p>You've been subscribing to this</p>
                                        <a href={PaymentRoutes.SubscriptionView(props.subscription.id, true, "")}>
                                            View the Subscription
                                        </a>
                                    </div>
                                </div>
                            </div>
                            :
                            (
                                button_visible ? <>
                                    <div className="d-flex flex-column justify-content-center align-items-center" style={{ marginTop: "auto" }}>
                                        <NSButtonBlue
                                            title={title}
                                            onClick={{
                                                action: () =>
                                                {
                                                    if (props.button?.onClick)
                                                        props.button.onClick();
                                                    else
                                                        props.url.redirect(
                                                            PaymentRoutes.OfferGateway(
                                                                parmas.product_slug ?? props.offer.product_id,
                                                                parmas.sales_item_slug ?? props.offer.sales_item_id,
                                                                props.offer.id,
                                                                true,
                                                                ""
                                                            ),
                                                            {}
                                                        );
                                                },
                                                showLoading: false
                                            }}
                                        />
                                    </div>
                                </>
                                    :
                                    <></>
                            )
                    }
                </div>
            </div>
        </div >
    );
}

export default NSPOfferCard;